import { createWidgetWithErrorBoundary } from '@alfa-bank/site-util-create-widget/create-widget-with-error-boundary';

import type { TMortgageDataManager, IDeps } from './models';
import { MortgageDataManager as Component } from './mortgage-data-manager';

export const MortgageDataManager = createWidgetWithErrorBoundary<IDeps, TMortgageDataManager>()(
    Component
);
